import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { OnboardingPageModel } from "src/app/models/onboarding/onboarding-page.model";
import { OnboardingService } from "./onboarding.service";
import { OnboardingStepTypeModel } from "src/app/models/onboarding/onboarding-step-type.model";
import { DrawerService } from "../drawer.service";

@Injectable({ providedIn: 'root' })
export class OnboardingFlowService {
  private pages: OnboardingPageModel[] = [];
  private currentIndex = 0;

  constructor(
    private onboardingService: OnboardingService,
    private router: Router,
    private drawerService: DrawerService
  ) {}

  loadPages(): Promise<void> {
    return new Promise((resolve) => {
      this.onboardingService.getOnboardingPages().subscribe(pages => {

        this.pages = (pages || []).sort((a, b) => 
          (a.sequence ?? 0) - (b.sequence ?? 0)
        );
        this.currentIndex = 0;

        resolve();
      });
    });
  }

  getCurrent(): OnboardingPageModel | null {
    return this.pages[this.currentIndex] || null;
  }

  getIndex(): number {
    return this.currentIndex;
  }

  getTotal(): number {
    return this.pages.length;
  }

  next(): void {
    if (this.currentIndex < this.pages.length - 1) {
      this.currentIndex++;
    }
  }

  back(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  executeStep(): void {
    const step = this.getCurrent();
    if (!step) return;

    if (
      step.stepType === OnboardingStepTypeModel.Action && 
      step.actionKey
    ) {
      this.handleAction(step.actionKey);
    } else if (
      step.stepType === OnboardingStepTypeModel.Navigate && 
      step.pageUrl
    ) {
      this.drawerService.close();
      this.router.navigate([step.pageUrl]);
    }
  }

  private handleAction(actionKey: string): void {
    switch (actionKey) {
      case 'OPEN_MENU':
        this.drawerService.open();
        break;

      default:
        console.warn('Unknown action:', actionKey);
    }
  }

  completeOnboarding(): void {
    this.onboardingService.completeOnboarding()
      .subscribe();
  }
}